
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Fracture_AO_classification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Fracture_AO_classification.vue